import {isProxy, toRaw} from 'vue';

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}


let handlers = [];
let error_handlers = [];
let ready = false;


const default_handler = (event) => {
    let message = event.data;
    // console.log("[main] message from worker thread:", message);
    let action = message.action;
    let data = message.data;
    
    let valid_handlers = handlers.filter(handler => handler.action === action);
    
    if (action === 'WORKER_READY') {
        ready = true;
    }

    valid_handlers.forEach(handler => {
        handler.callback(message.data);
    });
}

const database_worker = new Worker('./database-worker.js', { type: 'module', name: `${self.name}-worker` });
database_worker.onmessage = default_handler;
database_worker.onmessageerror = default_error_handler;



const addActionHandler = (action, callback) => {
    handlers.push({
        action,
        callback
    });
}

const removeActionHandler = (action, callback) => {
    let index = handlers.findIndex(handler => handler.action === action && handler.callback === callback);
    
    if (index < 0) return false;

    handlers.splice(index, 0);
    return true;
}

// ERRORS
const default_error_handler = (event) => {
    console.log("[main] error from worker thread:", event);
    error_handlers.forEach(handler => {
        handler.callback(event);
    });
};

const addErrorHandler = (callback) => {
    handlers.push(callback);
}

const removeErrorHandler = (callback) => {
    let index = handlers.findIndex(handler =>handler.callback === callback);
    
    if (index < 0) return false;

    handlers.splice(index, 0);
    return true;
}

const send = message => {
    // console.log("[main] sending message to worker thread:", message);
    database_worker.postMessage(message);
};



export default {
    worker: database_worker,
    send,
    addActionHandler,
    removeActionHandler
}